import { adminRolesConstants } from 'Constants/adminRole.costants';
import Request from 'Services/request';
import { toast as toastr } from 'react-toastify';
import { alterQueryRequest,  findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { dateAndTimeFormat, handleApiError } from 'Helpers/index';
import { ModuleActions } from 'Constants/Modules.constants';

const requestAdminRoles = adminRoleObject => ({
  type: adminRolesConstants.ADMIN_ROLES_REQUEST,
  adminRoleObject
})
const requestAdminFormRoles = adminRoleObject => ({
  type: adminRolesConstants.ADMIN_ROLES_FORM_REQUEST,
  adminRoleObject
})

const sucecessAdminRoles = adminRoleObject => ({
  id: Date.now(),
  type: adminRolesConstants.ADMIN_ROLES_GET_SUCCESS,
  adminRoleObject:adminRoleObject.data,
  totalRecords:adminRoleObject.count,
  currentPage:adminRoleObject.currentPage
})

const sucecessAllAdminRoles = adminRoleObject => ({
  type: adminRolesConstants.ALL_ADMIN_ROLES_GET_SUCCESS,
  adminRoleObject:adminRoleObject.data
})

const sucecessAllowedModules = allowedModulesObject => ({
  type: adminRolesConstants.ALLOWED_MODULES_GET_SUCCESS,
  allowedModulesObject:allowedModulesObject
})

const successUpdateAdminRoles = adminRoleObject =>({
  type: adminRolesConstants.ADMIN_ROLES_UPDATE_SUCCESS,
  adminRoleObject
})

const failureAdminRloes = error => ({
  type: adminRolesConstants.ADMIN_ROLES_FAILURE,
  error
})

const failureDeleteRloes = error => ({
  type: adminRolesConstants.ADMIN_DELETE_ROLES_FAILURE,
  error
})

const failureAdminFormRloes = error => ({
  type: adminRolesConstants.ADMIN_ROLES_FORM_FAILURE,
  error
})
const failureEditAdminFormRloes = error => ({
  type: adminRolesConstants.ADMIN_ROLES_EDIT_FORM_FAILURE,
  error
})

function fetchAlladminRoles() {
  const url = '/roles/names'
  return async (dispatch) => {
    dispatch(requestAdminRoles({}));
    await Request.get(url, {})
      .then((response) => {
        const { data } = response;
        dispatch(sucecessAllAdminRoles({ data }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAdminRloes(error.toString()));
        }
      });
  };
}

function fetchAdminRoles(SearchArray) {
  let url = '/roles'

  if(SearchArray && SearchArray.length > 0 ) {
    url = queryParser(url,SearchArray);
  } 
  const currentPage = findCurrentPageRequest(SearchArray);

  return async (dispatch) => {
    dispatch(requestAdminRoles({}));
    await Request.get(url, {})
      .then((response) => {
        const { data, count } = response;
        dispatch(sucecessAdminRoles({ data, count, currentPage }));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAdminRloes(error.toString()));
        }
      });
  };
}

function addAdminRoles(addAdminRolesObj,SearchArray) {
  return (dispatch) => {
    dispatch(requestAdminFormRoles({}));
    Request.create('/roles', { ...addAdminRolesObj })
      .then((response) => {
        const { message } = response;
        dispatch(fetchAdminRoles(SearchArray));
        toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAdminFormRloes(error.toString()));
        }
      })
  }
}

function updateAdminRoles(adminRolesObj) {
  const { id, ...rest } = adminRolesObj
 
  return (dispatch) => {
    dispatch(requestAdminFormRoles({}));
    Request.update(`/roles/${ id }`, { ...rest })
      .then((response) => {
        const { message } = response;
        dispatch(successUpdateAdminRoles(adminRolesObj));
        dispatch(fetchAdminRoles())
        toastr.dismiss()
        toastr.success(message)
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureEditAdminFormRloes(error.toString()));
        }
      })
  }
}

function deleteAdminRoles(id, SearchArray, remainningRecords,currentPage) {
  const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords,currentPage);
  return (dispatch) => {
    dispatch(requestAdminRoles({}));
    Request.remove('/roles',{ id: id  })
      .then((response) => {
        const { message } = response;
        dispatch(fetchAdminRoles(updateSearchArray));
        toastr.dismiss();
        toastr.success(message)
      })
      .catch((error) => {
        if(error) {
          dispatch(failureDeleteRloes(error.toString()));
        }
      })
  }
}

function fetchAllowedModules(){
  const url = '/roles/allowedmodules'
  return async (dispatch) => {
    dispatch(requestAdminRoles({}));
    await Request.get(url, {})
      .then(( response ) => {
        const { data } = response;
        dispatch(sucecessAllowedModules( data ));
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failureAdminRloes(error.toString()));
        }
      });
  };
}

const requestRoleExportData = exportData => ({
    type: adminRolesConstants.EXPORT_ROLES_REQUEST,
    exportData
})

const successRoleExportData = exportDataObj => ({
    type: adminRolesConstants.EXPORT_ROLES_SUCCESS,
    exportData: exportDataObj.data,
    totalRecords: exportDataObj.count
})

const failureRoleExportData = error => ({
    type: adminRolesConstants.EXPORT_ROLES_FAILURE,
    error
})

function exportRole(SearchArray) {
    let url = '/roles';
    if (SearchArray && SearchArray.length > 0) {
      url = queryParser(url, SearchArray);
    }

    const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
    url = `${ url }${ exportUrl }`;

    return async (dispatch) => {
        dispatch(requestRoleExportData({}));
        await Request.get(url, {})
            .then(response => {
                const { data: resData = [] } = response;
                const data = resData.map(function(res){
                  const obj = {};
                  obj[ 'Role Name' ] = res.roleName;
                  obj[ 'No. of Admin Users' ] = res.noOfAdminUsers;
                  const allowedModules = JSON.parse(res.allowedModules || '{}'), moduleKeys = Object.keys(allowedModules || {});
                  const beautifiedAllowedModules = moduleKeys.filter(
                    m => 
                      allowedModules?.[ m ]?.[ ModuleActions.view ] ||
                      allowedModules?.[ m ]?.[ ModuleActions.create ] ||
                      allowedModules?.[ m ]?.[ ModuleActions.edit ] ||
                      allowedModules?.[ m ]?.[ ModuleActions.delete ]
                  ).join(', ');
                  obj[ 'Allowed Modules' ] = beautifiedAllowedModules;
                  const createAt = dateAndTimeFormat(res.createdAt);
                  const updateAt = dateAndTimeFormat(res.updateAt);
                  obj[ 'Created Date' ] = createAt;
                  obj[ 'Updated Date' ] = updateAt;
                  return obj;
                });
                dispatch(successRoleExportData({ data }));
            })
            .catch((error) => {
                if(error) {
                  handleApiError(error);
                  dispatch(failureRoleExportData(error.toString()));
                }
            });
    };
}

export const manageAdminRolesActions = {
  fetchAdminRoles,
  addAdminRoles,
  updateAdminRoles,
  fetchAlladminRoles,
  deleteAdminRoles,
  fetchAllowedModules,
  exportRole,
}
